(function () {
  var loaded = false;

  function loadScripts() {
    if (loaded) return;

    // Disconnect only if an observer exists and supports this method.
    if (
      typeof observer !== "undefined" &&
      observer &&
      typeof observer.disconnect === "function"
    ) {
      observer.disconnect();
    }

    loaded = true;

    document.querySelectorAll("iframe.lazy").forEach(function (frame) {
      var source = frame.getAttribute("data-src");
      if (source !== null) {
        frame.src = source;
      }
    });

    // Use a snapshot so replacing elements does not shift the list.
    Array.from(document.querySelectorAll("script")).forEach(function (script) {
      var source = script.getAttribute("data-src");

      if (script.getAttribute("type") === "text/lazyload") {
        var replacement = document.createElement("script");

        Array.from(script.attributes).forEach(function (attribute) {
          replacement.setAttribute(attribute.name, attribute.value);
        });

        replacement.type = "text/javascript";

        if (source !== null) {
          replacement.setAttribute("src", source);
          replacement.removeAttribute("data-src");
        }

        replacement.textContent = script.textContent;

        // Replace while the original still has its parent.
        if (script.parentNode) {
          script.parentNode.replaceChild(replacement, script);
        }
      } else if (source !== null) {
        script.setAttribute("src", source);
        script.removeAttribute("data-src");
      }
    });

    document.querySelectorAll("link[data-href]").forEach(function (link) {
      link.setAttribute("href", link.getAttribute("data-href"));
      link.removeAttribute("data-href");
    });

    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  }

  [
    "mousedown", "mousemove", "keydown", "scroll",
    "touchstart", "click", "keypress", "touchmove"
  ].forEach(function (eventName) {
    window.addEventListener(eventName, loadScripts, { once: true });
  });
})();